<template>
  <div>
    <div  class="h-topo_pw2" v-show="see" :style="PositionXY">
      <!-- <div class="h-topo_pw"> -->

      <div class="h-topo_pw_top">
        <div class="h-topo_wytb1">
         <span :class="['icon hero-icon hero-icon-topo-subet '+online]"></span>

        </div>
        <div class="h-topo_wytb_topwz" :title='devInfo.name'>{{$t('Topo.subnetName')}}：{{devInfo.name}}</div>
        <div class="h-topo_wytb2">
          <span @click="click()" class="e-btn-icon icon hero-icon hero-icon-Expand"></span>
        </div>
      </div>
      <div class="h-topo_pw_bottom" v-if="seeBottom">
        <div class="h-topo_wybox">
          <div class="h-topo_wytb3"></div>
          <div class="h-topo_wytb3">
            <span class="e-btn-icon icon hero-icon hero-icon-detailed"></span>
          </div>
          <div class="h-topo_xq">{{$t('Topo.serveDetail')}}</div>
          <div class="h-topo_wytb_wz">
            <table class="h-topo_tableheight">
              <tr>
                <td>{{$t('Topo.subnetID')}}: {{devInfo.id}}</td>
              </tr>
              <tr>
                <td>{{$t('Topo.subnetDes')}}: {{devInfo.description}}</td>
              </tr>
            </table>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>
<script>


export default {
  name: "SubnetPanelBoardShow",
  components: {

  },
  data() {
    return {
		//-- view to left or right
		PositionXY: '',
		typeCode: "",
		devInfo: {},
		see: false,
		seeBottom: false,
		id: "",
		type: "",
		online:'',

    };
  },
  props: ["subnetShowObj"],
  methods: {
    panelBoardGetData() {
      this.axios
        .get(`/lte/ems/topo/subnet/findSubnet/${this.id}`)
        .then(response => {
          if (response.data.errorCode === 'SUCCESS') {
            this.devInfo = response.data.resultVal;
          }
        });
    },

    click() {
      this.seeBottom = !this.seeBottom;
      this.see = !this.see;
    },

  },

  mounted() {},
  watch: {
    //父子动态传值
    subnetShowObj: {
      handler: function(newVal, oldVal) {
        this.see = newVal.seeObj;
        this.seeBottom = newVal.seeBottomObj;
        this.id = newVal.idObj;

        if(newVal.onlineObj===1)
        	this.online='h-pm-iconOnline';
        else if(newVal.onlineObj===0)
        	this.online='h-pm-iconOffline';

		this.PositionXY = newVal.PositionXY;
        this.panelBoardGetData();
      },
      deep: true
    }
  }
};
</script>

